import { Switch } from "V2.0/common/switch";

export function CalendarSearchEnabled(props) {
  const { calendarSearchEnabled, updateCalendarSearchEnabled, locked } = props;

  return (
    <div className="space-y-2">
      <div className="flex gap-x-2 items-center">
        <p className="text-base font-medium">Book Appointments</p>
        <Switch
          color="emerald"
          checked={calendarSearchEnabled}
          onClick={updateCalendarSearchEnabled}
          disabled={locked}
        />
      </div>
    </div>
  );
}
